import * as React from 'react';

export const SvgPaperAirplane = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M0 24L24 12L0 0V9.23077L16 12L0 14.7692V24Z" fill="#404040" />
    </svg>
  );
};
